import { render, staticRenderFns } from "./MenuNft.vue?vue&type=template&id=503485cf&scoped=true"
import script from "./MenuNft.vue?vue&type=script&lang=js"
export * from "./MenuNft.vue?vue&type=script&lang=js"
import style0 from "./MenuNft.vue?vue&type=style&index=0&id=503485cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503485cf",
  null
  
)

export default component.exports